// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__O-ury","animateBg":"Skeleton_animateBg__1c5Qx","skeleton-alt":"Skeleton_skeleton-alt__3fMhS"};